<div class="bg-img-circule">
  <img src="../../../../assets/images/Home-2.png" />
</div>
<app-menu-template1>
  <main>
    <article class="row ml-5 mr-5 mt-4 mb-3">
      <section class="col-12 rounded p-5 mt-4 shadow bg-white mb-5">
        <h1 class="h4 mb-2 d-flex justify-content-center mb-5">Reporte estadístico</h1>
        <div class="card mb-3">
          <div class="card-body mb-4">
            <form [formGroup]="reporte" (ngSubmit)="enviarForm()">
              <p class="font-weight-bold h6 mt-3">Seleccione el tipo de reporte</p>
              <div class="row">

                <div class="col-sm-12 col-md-4 form-group">
                  <!-- <label class="small text-secondary mb-0" for="codigo_camara">Tipo de reporte</label>
                  <select class="form-control form-control-sm" formControlName="tipo_reporte">
                    <option [ngValue]="null" [selected]="true">
                      Seleccione
                    </option>
                    <option>Reporte por Estados</option>
                    <option>Reporte por Geográfico</option>
                    <option>Reporte por Categorías</option>
                  </select> -->
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de reporte</mat-label>
                    <mat-select formControlName="tipo_reporte">
                      <mat-option value="est">Reporte por Estados</mat-option>
                      <mat-option value="dep">Reporte por Departamentos</mat-option>
                      <mat-option value="cat">Reporte por Categorías</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="">
                <p class="font-weight-bold h6" *ngIf="reporte.value.tipo_reporte === estados">Reporte por Estados</p>
                <p class="font-weight-bold h6" *ngIf="reporte.value.tipo_reporte === departamento">Reporte por
                  Departamentos</p>
                <p class="font-weight-bold h6" *ngIf="reporte.value.tipo_reporte === categoria">Reporte por Categorías</p>
              </div>
              <div class="row">
                <ng-container formGroupName="reporteGroup" *ngIf="reporte.value.tipo_reporte === estados">
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Estados</mat-label>
                      <mat-select formControlName="estados_rnt" multiple disableOptionCentering>
                        <mat-option *ngFor="let estado_rnt of estadoRNTLista" [value]="estado_rnt.estado_rnt_id">{{estado_rnt.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Departamentos</mat-label>
                      <mat-select formControlName="departamentos" multiple disableOptionCentering>
                        <mat-option *ngFor="let departamento of departamentos" [value]="departamento.departamento_id">{{departamento.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Categorias</mat-label>
                      <mat-select formControlName="categorias" multiple disableOptionCentering>
                        <mat-option *ngFor="let categoria of categoriasLista" [value]="categoria.categoria_id">{{categoria?.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>
                <ng-container formGroupName="reporteGroup" *ngIf="reporte.value.tipo_reporte === departamento">
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Departamentos</mat-label>
                      <mat-select formControlName="departamentos" multiple disableOptionCentering>
                        <mat-option *ngFor="let departamento of departamentos" [value]="departamento.departamento_id">{{departamento.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Estados</mat-label>
                      <mat-select formControlName="estados_rnt" multiple disableOptionCentering>
                        <mat-option *ngFor="let estado_rnt of estadoRNTLista" [value]="estado_rnt.estado_rnt_id">{{estado_rnt.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Categorias</mat-label>
                      <mat-select formControlName="categorias" multiple disableOptionCentering>
                        <mat-option *ngFor="let categoria of categoriasLista" [value]="categoria.categoria_id">{{categoria?.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>
                <ng-container formGroupName="reporteGroup" *ngIf="reporte.value.tipo_reporte === categoria">
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Categorias</mat-label>
                      <mat-select formControlName="categorias" multiple disableOptionCentering>
                        <mat-option *ngFor="let categoria of categoriasLista" [value]="categoria.categoria_id">{{categoria?.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Departamentos</mat-label>
                      <mat-select formControlName="departamentos" multiple disableOptionCentering>
                        <mat-option *ngFor="let departamento of departamentos" [value]="departamento.departamento_id">{{departamento.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-sm-12 col-md">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Estados</mat-label>
                      <mat-select formControlName="estados_rnt" multiple disableOptionCentering>
                        <mat-option *ngFor="let estado_rnt of estadoRNTLista" [value]="estado_rnt.estado_rnt_id">{{estado_rnt.descripcion}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
              <div class="row form-row" *ngIf="reporte.value.tipo_reporte">
                <div class="col-md-3 col-sm-12">
                </div>
                <div class="col-md-3 col-sm-12 text-center">
                  <button class="btn btn-primary m-auto solicitud-btn-principal w-100" type="submit" [disabled]="!reporte.valid">Generar</button>
                </div>
                <div class="col-md-3 col-sm-12 text-center">
                  <button type="reset" class="btn btn-outline-primary border-0 m-auto w-100" (click)="limpiar()">Limpiar</button>
                </div>
                <div class="col-md-3 col-sm-12">
                </div>
              </div>
            </form>
          </div>
        </div>
        <p *ngIf="datosGrafica && datosGrafica.length == 0 && show">No se han encontrado
          resultados para
          la búsqueda
          realizada.</p>
        <p class="font-weight-bold h5" *ngIf="dataTabla.paging.totalItems >= 1">Histórico de datos</p>
        <app-tablas [page] = "paginaActual" [headers]="headersRnt" [sizeData]="dataTabla.paging.totalItems" class="table-responsive" (paginado)="onPaginado($event)"
          *ngIf="dataTabla.paging.totalItems >= 1">
          <tr *ngFor="let item of dataTabla.items; let i=index" class="small">
            <td>{{item.desc_estado_rnt}}</td>
            <td>{{item.desc_dpto}}</td>
            <td>{{item.desc_categoria}}</td>
            <td>{{item.cantidad}}</td>
          </tr>
        </app-tablas>
        <p class="font-weight-bold h5" *ngIf="datosGrafica && datosGrafica.length >= 1">Gráfica de datos</p>
        <google-chart class="w-100 h-25" [type]="myType" [data]="datosGrafica" [dynamicResize]="true" [options]="configuracionChart"
          *ngIf="datosGrafica && datosGrafica.length >= 1">
        </google-chart>

        <!-- <ng-template #no_data>
          <section class="row text-center">
            <header class="col-12">
              <figure class="figure w-100">
                <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
                <figcaption>
                  <label class="h3">Aún no tiene solicitudes RNT</label>
                </figcaption>
              </figure>
            </header>
            <footer class="col-md-6 m-auto">
              <p class="text-muted">Aquí se mostrarán todas las solicitudes RNT por cada
                establecimiento registrado</p>
            </footer>
          </section>
        </ng-template> -->
        <!-- <aside>
          <p>
            <strong>¿Qué signican los estados de RNT?</strong>
          </p>
        </aside> -->
        <br>
        <br>
      </section>
    </article>
  </main>
</app-menu-template1>